import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { connect } from "react-redux";
import Modal from "modules/common/components/Modal";
import withForm from 'modules/common/hoc/withForm';
import useFormValidator from 'useFormValidator';
import FormInputMobile from "modules/common/components/FormInputMobile";
import InputMask from 'react-input-mask';
import Address from "modules/common/address/Address";
import Select from 'react-select';
import { ModalContext } from "App";
import { EXTENSION_NAMES, formatMobileNumber, STATUS_OPTIONS } from "helper";
import PropTypes from "prop-types";
import * as actions from "../action";

function BuildingOwnerModal({
  createData,
  type,
  dataInfo,
  updateData,
  history,
  getList,
  showData,
  id,
}) {

  const [formMobile, setFormMobile] = useState({});

  const setModal = useContext(ModalContext);

  const [formData, setFormData] = useState({
    first_name: '',
    middle_name: '',
    last_name: '',
    suffix: '',
    status: '',
    authorized_representative: '',
    municipality_code: '',
    barangay_code: '',
    address_line: '',
    tin: '',
    telephone_no: '',
    mobile_number: '',
    email: '',
  });

  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    status: 'required',
    authorized_representative: 'required_if:status=CORPORATION',
    municipality_code: 'required',
    barangay_code: 'required',
    address_line: 'required',
    tin: 'required|tin_no',
    telephone_no: 'required|tel_number',
    mobile_number: 'cellphone_number',
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      mobile_number: formatMobileNumber(formMobile.mobile_number) || "",
    };

    if (type === 'NEW') {
      createData(args, (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/building/building-owners/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

    if (type === 'EDIT') {
      updateData(id, args, (data) => {
        setModal({ isOpen: false });
        getList();
        history.push(
          `/rpt/building/building-owners/${data.data.id}`
        );
        showData(data.data.id);
      });
    }

  };

  const handleOnClose = (e) => {
    if (e) e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (type === "EDIT") {
      setFormMobile({
        mobile_number: _.get(dataInfo, 'mobile_number'),
      });
      setFormData({
        ...formData,
        first_name: _.get(dataInfo, 'first_name'),
        middle_name: _.get(dataInfo, 'middle_name'),
        last_name: _.get(dataInfo, 'last_name'),
        suffix: _.get(dataInfo, 'suffix'),
        status: _.get(dataInfo, 'status'),
        authorized_representative: _.get(dataInfo, 'authorized_representative'),
        region_code: _.get(dataInfo, 'region_code'),
        province_code: _.get(dataInfo, 'province_code'),
        municipality_code: _.get(dataInfo, 'municipality_code'),
        barangay_code: _.get(dataInfo, 'barangay_code'),
        address_line: _.get(dataInfo, 'address_line'),
        telephone_no: _.get(dataInfo, 'telephone_no'),
        tin: _.get(dataInfo, 'tin'),
        email: _.get(dataInfo, 'email'),
      });
    }
  }, []);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const onChangeAddress = e => {
    setFormData({
      ...formData,
      region_code: e.target.value.region_code,
      province_code: e.target.value.province_code,
      municipality_code: e.target.value.municipality_code,
      barangay_code: e.target.value.barangay_code,
      street: e.target.value.street || '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className='row'>
          <div className='col-6 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              First Name &nbsp;{' '}
              {validateForm.renderMessage('first_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="first_name"
              onChange={onChange}
              value={_.get(formData, 'first_name') || ''}
            />
          </div>
          <div className='col-6 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Middle Name &nbsp;{' '}
            </label>
            <input
              className="form-control"
              type="text"
              name="middle_name"
              onChange={onChange}
              value={_.get(formData, 'middle_name') || ''}
            />
          </div>
          <div className='col-6 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Last Name &nbsp;{' '}
              {validateForm.renderMessage('last_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="last_name"
              onChange={onChange}
              value={_.get(formData, 'last_name') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Suffix
            </label>
            <Select
              name="suffix"
              placeholder="-Select-"
              onChange={handleOnChangeSelect('suffix')}
              options={EXTENSION_NAMES}
              value={
                EXTENSION_NAMES.find(
                  item =>
                    _.get(formData, 'suffix') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Status {validateForm.renderMessage('status')}
            </label>
            <Select
              name="status"
              placeholder="-Select-"
              onChange={handleOnChangeSelect('status')}
              options={STATUS_OPTIONS}
              value={
                STATUS_OPTIONS.find(
                  item =>
                    _.get(formData, 'status') ===
                    _.get(item, 'value')
                ) || ''
              }
            />
          </div>
          <div className='col-6 form-group'>
            <label htmlFor="last_name" className="form-label mb-0">
              Authorized Representative &nbsp;{' '}
              {validateForm.renderMessage('authorized_representative')}
            </label>
            <input
              className="form-control"
              type="text"
              name="authorized_representative"
              onChange={onChange}
              value={_.get(formData, 'authorized_representative') || ''}
            />
          </div>
        </div>
        <hr />
        <Address
          value={{
            region_code: _.get(formData, 'region_code') || '',
            province_code:
              _.get(formData, 'province_code') || '',
            municipality_code:
              _.get(formData, 'municipality_code') || '',
            barangay_code:
              _.get(formData, 'barangay_code') || '',
          }}
          onChange={onChangeAddress}
          region_name="region_code"
          province_name="province_code"
          municipality_name="municipality_code"
          barangay_name="barangay_code"
          withStreet={false}
          removeLabel
          validatorMessage={validateForm.renderMessage}
        />
        <div className='row mt-2'>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Unit No. / House No. / Street Name{' '} {validateForm.renderMessage('address_line')}
            </label>
            <input
              className="form-control"
              type="text"
              name="address_line"
              onChange={onChange}
              value={_.get(formData, 'address_line') || ''}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Tax Identification Number (TIN)
              {validateForm.renderMessage('tin')}
            </label>
            <InputMask
              className="form-control"
              mask="999-999-999-999"
              alwaysShowMask={false}
              type="text"
              name="tin"
              onChange={onChange}
              value={_.get(formData, 'tin') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Telephone No.{' '}
              {validateForm.renderMessage('telephone_no')}
            </label>
            <InputMask
              className="form-control"
              mask="99-9999-9999"
              alwaysShowMask={false}
              type="text"
              name="telephone_no"
              onChange={onChange}
              value={_.get(formData, 'telephone_no') || ''}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Mobile Number
            </label>
            <FormInputMobile
              className="form-control"
              mask="+639999999999"
              placeholder="+63"
              name="mobile_number"
              onChange={setFormMobile}
              value={formMobile.mobile_number || ''}
              disableDropdown={false}
            />
          </div>
          <div className='col-6 form-group'>
            <label htmlFor="last_name" className="form-label">
              Email Address
            </label>
            <input
              className="form-control"
              type="email"
              name="email"
              onChange={onChange}
              value={_.get(formData, 'email') || ''}
            />
          </div>
        </div>
        <hr className="below-hr" />
        <div className='d-flex justify-content-center mt-5'>
          <button
            type='button'
            onClick={handleOnClose}
            className='btn btn-light mr-2'
          >
            Cancel
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            type='submit'
            className='btn btn-md btn-primary cms-bg-color-primary cms-outline-primary mr-1 cms-bg-color-primary'
          >
            Submit
          </button>
        </div>

      </form>
    </Modal.Body>
  );
}

BuildingOwnerModal.defaultProps = {
  type: '',
  dataInfo: {},
  id: '',
};

BuildingOwnerModal.propTypes = {
  createData: PropTypes.instanceOf(Function).isRequired,
  updateData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  history: PropTypes.instanceOf(Object).isRequired,
  dataInfo: PropTypes.instanceOf(Object),
  getList: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withRouter,
  withForm,
  connect(mapStateToProps, actions),
]);

export default enhance(BuildingOwnerModal);
